// extracted by mini-css-extract-plugin
export default {"mitre-widget":"MitreWidget-module__mitre-widget__DddqU","mitreWidget":"MitreWidget-module__mitre-widget__DddqU"};